// extracted by mini-css-extract-plugin
export var readonly = "_fg-1";
export var star = "_fg-0";